// Numbered vertical steps (post-payment onboarding). Structure adapted from
// cosscom/coss apps/origin/registry/default/ui/timeline.tsx — MIT (indicator + separator +
// title/content), reduced to a static ordered list: no active-step context, no colour
// state. The <ol> carries the numbering for assistive tech; the drawn number is decorative.

import type { ReactNode } from "react";
import { dataClass } from "@ahcut/ui/recipes";
import { cn } from "@/lib/cn";

export function Steps({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <ol data-slot="steps" className={cn("flex flex-col", className)}>
      {children}
    </ol>
  );
}

export function Step({
  number,
  title,
  children,
}: {
  number: number;
  title: ReactNode;
  children?: ReactNode;
}) {
  return (
    <li
      data-slot="step"
      className="group/step relative grid grid-cols-[2rem_minmax(0,1fr)] gap-x-4 pb-6 last:pb-0"
    >
      <span
        aria-hidden="true"
        className={cn(
          dataClass,
          "flex size-8 items-center justify-center rounded-full border border-line-strong bg-surface-0 text-sm text-fg-0",
        )}
      >
        {number}
      </span>
      <span
        aria-hidden="true"
        className="absolute top-9 bottom-1 left-4 w-px -translate-x-1/2 bg-line-strong group-last/step:hidden"
      />
      <div className="flex min-w-0 flex-col gap-3 pt-1">
        <h3 className="text-base font-medium text-fg-0">{title}</h3>
        {children}
      </div>
    </li>
  );
}
